import angular from 'angular';
// import zTreeTemplate from './zTree.html'
const zTree = angular.module('app.zTree', []);

export default zTree.name;

import template from './zTree.html';
import fuzzySearch from './fuzzysearch';

zTree.directive('zTree', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        treeData: '<',
        ngModel: '=',
        config: '<',
        name: '@',
        parentCheck: '=',
        searchOpen: '=',
        nodeCheckReset: '=',
      },
      template: template,
      controller: [
        '$scope',
        function ($scope) {
          $scope.isCheckAll = true;
          let randomId = Math.random().toString().substr(2, 10);
          $scope.domId = 'z-tree' + randomId;
          $scope.keyId = 'key' + randomId;
          var setting = {
            view: {
              showIcon: false,
            },
            check: {
              enable: true, //显示不显示复选框
              chkboxType: { Y: '', N: '' },
            },
            data: {
              simpleData: {
                enable: true, //使用不使用简单数据模式
                idKey: 'orgId', //节点数据中保存唯一标识的属性名称 默认值id
                pIdKey: 'parentOrgId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                rootPId: 0, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
              },
              key: {
                name: 'orgName',
              },
            },
            callback: {
              onCheck: function () {
                var treeObj = $.fn.zTree.getZTreeObj($scope.domId);
                // var nodes = treeObj.getCheckedNodes(true);
                var nodes = treeObj.getNodes();
                var allNodes = treeObj.transformToArray(nodes);
                var checkedNodes = allNodes.filter(function (ele) {
                  return ele.checked === true;
                });
                $scope.ngModel = checkedNodes;
                $scope.$emit('node-change', checkedNodes);
                $scope.$apply();
                isCheckAllShowHook(allNodes);
              },
            },
          };
          $scope.$watch('config', function (newValue, oldValue) {
            setting = $.extend(true, setting, newValue);
            $scope.setting = setting;
          });
          function isCheckAllShowHook(allNodes) {
            var isCheckShowHook = allNodes.every(
              (item) => item.checked === true
            );
            $scope.isCheckAll = isCheckShowHook;
            //解决脏数据问题
            $scope.$apply();
          }
          $scope.firstWatch = 1;
          $scope.$watch('treeData', function (newValue, oldValue) {
            if (newValue) {
              initialDataIsAllSelected(newValue);
              if ($scope.ngModel && $scope.ngModel.length) {
                $scope.firstWatch++;
                $scope.treeData.forEach((element) => {
                  $scope.ngModel.forEach((ele) => {
                    if (ele.orgId === element.orgId) {
                    //   element.checked = true;
                    }
                  });
                });
              }
              $.fn.zTree.init($('#' + $scope.domId), setting, $scope.treeData);
              $scope.zTree = $.fn.zTree.getZTreeObj($scope.domId);
              fuzzySearch(
                $scope.domId,
                '#' + $scope.keyId,
                true,
                false,
                $scope
              );
            }
          });
          //初始数据是否全选
          function initialDataIsAllSelected(allNodes) {
            let isCheckShowHook = allNodes.every(
              (item) => item.checked === true
            );
            $scope.isCheckAll = isCheckShowHook;
          }
          $scope.$on('Tree.ClearAll', function ($event, type) {
            if (!type || (type && type === $scope.name)) {
              var treeObj = $.fn.zTree.getZTreeObj($scope.domId);
              treeObj.checkAllNodes(false);
              $scope.ngModel = [];
            }
          });
          // 全选
          $scope.checkAll = function (isCheckAll) {
            var zTree = $.fn.zTree.getZTreeObj($scope.domId);
            if (isCheckAll) {
              zTree.checkAllNodes(true);
              $scope.$emit('node-change', $scope.treeData);
            } else {
              zTree.checkAllNodes(false);
              $scope.$emit('node-change', []);
            }
            $scope.parentCheck(isCheckAll);
          };
          $scope.$on($scope.nodeCheckReset, function (event, data) {
            console.log($scope);
            let zTree = $.fn.zTree.getZTreeObj($scope.domId);
            $scope.$emit('node-change', $scope.treeData);
            if (!data.length) {
              $scope.isCheckAll = false;
              zTree.checkAllNodes(false);
            }
          });
          // httpRequest.get_selectOrgAndChilds().then(res=>{
          //     let zNodes = res.data.value
          // var code;
          // function setCheck() {
          //     var zTree = $.fn.zTree.getZTreeObj("z-tree"),
          //         py = $("#py").attr("checked") ? "p" : "",
          //         sy = $("#sy").attr("checked") ? "s" : "",
          //         pn = $("#pn").attr("checked") ? "p" : "",
          //         sn = $("#sn").attr("checked") ? "s" : "",
          //         type = { "Y": py + sy, "N": pn + sn };
          //     zTree.setting.check.chkboxType = type;
          //     showCode('setting.check.chkboxType = { "Y" : "' + type.Y + '", "N" : "' + type.N + '" };');
          // }
          // function showCode(str) {
          //     if (!code) code = $("#code");
          //     code.empty();
          //     code.append("<li>" + str + "</li>");
          // }
          // setCheck();
          // $("#py").bind("change", setCheck);
          // $("#sy").bind("change", setCheck);
          // $("#pn").bind("change", setCheck);
          // $("#sn").bind("change", setCheck);

          // })

          // var treeDom =  $('#z-tree')
          // var zNodes = [
          //     { id: 1, pId: 0, name: "随意勾选 1", open: true },
          //     { id: 11, pId: 1, name: "随意勾选 1-1", open: true },
          //     { id: 111, pId: 11, name: "随意勾选 1-1-1" },
          //     { id: 112, pId: 11, name: "随意勾选 1-1-2" },
          //     { id: 12, pId: 1, name: "随意勾选 1-2", open: true },
          //     { id: 121, pId: 12, name: "随意勾选 1-2-1" },
          //     { id: 122, pId: 12, name: "随意勾选 1-2-2" },
          //     { id: 2, pId: 0, name: "随意勾选 2", checked: true, open: true },
          //     { id: 21, pId: 2, name: "随意勾选 2-1" },
          //     { id: 22, pId: 2, name: "随意勾选 2-2", open: true },
          //     { id: 221, pId: 22, name: "随意勾选 2-2-1", checked: true },
          //     { id: 222, pId: 22, name: "随意勾选 2-2-2" },
          //     { id: 23, pId: 2, name: "随意勾选 2-3" }
          // ];
        },
      ],
    };
  },
]);



// WEBPACK FOOTER //
// ./src/components/zTree/index.js